// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ZoomToFitIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ZoomToFitIcon" ref={forwardedRef} {...props}>
      <path d="M3.5 5.422V3.498h1.929v-1.5H3a1 1 0 0 0-1 1v2.424z" />
      <path d="M16.5 3.498h-1.929v-1.5H17a1 1 0 0 1 1 1v2.424h-1.5z" />
      <path d="M16.5 14.569H18v2.429a1 1 0 0 1-1 1h-2.429v-1.5H16.5z" />
      <path d="M5.429 16.498H3.5v-1.929H2v2.429a1 1 0 0 0 1 1h2.429z" />
      <path d="M5.25 6.248h9.5v7.5h-9.5zm1.5 1.5v4.5h6.5v-4.5z" />
    </SvgIcon>
  );
});

/**
 * Zoom to fit the motive in the frame
 * @public
 */
export const ZoomToFitIcon = /* @__PURE__ */ Object.assign(
  ZoomToFitIconComponent,
  { displayName: 'ZoomToFitIcon' },
);
